import React from "react";

const AuditLogs = () => {
    return (
        <div className="container">
            <h1>Audit Logs</h1>
            <p>
                Keep track of system activities with detailed audit logs. Gain insights into
                system operations and ensure compliance with regulatory standards.
            </p>
            <p>
                Benefits of Audit Logs:
                <ul>
                    <li>Complete activity tracking</li>
                    <li>Regulatory compliance</li>
                    <li>Detailed reporting for audits</li>
                </ul>
            </p>
        </div>
    );
};

export default AuditLogs;
